import type { SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  color?: string
}
export function BagCartOutline(props: Props) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9173 5.73266C11.2546 6.68455 10.7996 8.13017 10.7996 10.0001H9.08532C9.08532 7.86995 9.60172 6.05843 10.5104 4.75317C11.4261 3.438 12.7556 2.62863 14.2853 2.62863C15.8285 2.62863 17.1554 3.47994 18.0631 4.80018C18.9669 6.11487 19.4853 7.92261 19.4853 10.0001H17.771C17.771 8.19179 17.318 6.7424 16.6504 5.77137C15.9867 4.80589 15.1421 4.34292 14.2853 4.34292C13.415 4.34292 12.5731 4.7907 11.9173 5.73266ZM2.82275 11.7715H25.7479L23.1243 23.8899C22.9213 24.8872 22.0891 25.4858 21.1425 25.4858H7.42818C6.48154 25.4858 5.64931 24.8872 5.44633 23.8899L2.82275 11.7715ZM4.94789 13.4858L7.12592 23.5462C7.14503 23.6418 7.18341 23.6871 7.21488 23.7118C7.24943 23.7389 7.31532 23.7715 7.42818 23.7715H21.1425C21.2553 23.7715 21.3212 23.7389 21.3558 23.7118C21.3872 23.6871 21.4257 23.6418 21.4448 23.5462L21.4475 23.533L23.6228 13.4858H4.94789Z"
        fill={props.color ?? '#15181B'}
      />
    </svg>
  )
}
